/* global jQuery Swiper initMap tgInit */

; (function ($) {
	$(document).ready(function () {
		// runs for first page load
		init()
	})

	function init() {
		/**
			* Run initialition for core functionality
			*/
		coreInit()

		/**
			* run initialisation for external scripts
			*/
		animationInit()
		//initMap()
		gridSlider()
	}

	function coreInit() {
		// helps us detect touchscreen-based browsers
		window.isTouch = false
		$(window).one('touchstart', function onFirstTouch() {
			window.isTouch = true
			$('body').addClass('is-touch')
		})

		setScrollbar()

		/**
			* General/global
			*/
		$('[input-select-all]').on('focus click', function () {
			setTimeout(() => {
				this.focus()
				this.setSelectionRange(0, 99999)
				this.select()
			}, 50)
		})

		/**
			* navigation
			*/
		// mobile nav toggle
		$('#nav-toggle').click(function () {
			$('#site-navigation').toggleClass('toggled')
			$('#nav-toggle').toggleClass('toggled')
			$('body').toggleClass('is-no-scroll')
			$('#primary-menu .menu-item-has-children>a').removeClass('active').next().slideUp(200)
			$(this).attr(
				'aria-expanded',
				$(this).attr('aria-expanded') === 'false'
			)
		})
		// if mobile nav or if touchscreen, menu items with children can not be followed
		$('#primary-menu .menu-item-has-children>a').click(function (e) {
			if ($(window).width() < 996 || window.isTouch) {
				e.preventDefault()
				e.stopPropagation()
			}
		})
		// mobile menu sub-menu handling
		$('#primary-menu .menu-item-has-children>a').click(function (e) {
			if ($('#site-navigation').hasClass('toggled')) {
				console.log($(this).html());
				e.preventDefault()
				let dir = $(this).parent().attr('aria-expanded') === 'true'
				if (dir) {
					$(this).next().slideUp(200)
					$(this).parent().attr('aria-expanded', 'false')
					$(this).parent().removeClass('expanded')
				} else {
					$(this).next().slideDown(200)
					$(this).parent().attr('aria-expanded', 'true')
					$(this).parent().addClass('expanded')
				}
			}
		})
		// when mobile menu open a click to anything else closes it
		$(document).click(function (event) {
			if (!$(event.target).closest('#site-navigation .site-mask, #nav-toggle').length && $('#site-navigation').hasClass('toggled')) {
				$('#site-navigation').removeClass('toggled')
				$('#nav-toggle').removeClass('toggled')
				$('body').removeClass('is-no-scroll')
			}
		})
		// mobile home nav background
		if ($('body').hasClass('home')) {
			navBg()
			$(document).on('scroll.headerbg', throttle(function () {
				navBg()
			}, 50))
			$(document).on('resize.headerbg', throttle(function () {
				navBg()
			}, 50))
		}
		function navBg() {
			if ($(window).width() < 996) {
				let opacity = $(window).scrollTop() / 400
				$('#header .header-bg').css('opacity', opacity > 0.85 ? 0.85 : opacity)
			} else {
				$('#header .header-bg').css('opacity', '')
			}
		}

		/**
			* page head — carousel
			*/
		if ($('.v-pageHead__slide', '.v-pageHead__slider').length > 1) {
			new Swiper('.v-pageHead__slider', {
				autoplay: {
					delay: 7000
				},
				loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			})
		}

		/**
			* testimonials
			*/
		new Swiper('.v-testimonials .swiper-container', {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 10,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
		})

		/**
			* gallery section
			*/
		let galleryInit = false
		gallerySlider()
		function gallerySlider() {
			if (window.innerWidth < 992 && !galleryInit) {
				new Swiper('.v-gallery .swiper-container', {
					slidesPerView: 1,
					breakpoints: {
						768: {
							slidesPerView: 2
						}
					}
				})
				galleryInit = true
			} else if (window.innerWidth >= 992 && galleryInit) {
				$('.v-gallery .swiper-container').each(function () {
					$(this)[0].swiper.destroy()
				})
				galleryInit = false
			}
		}
		$(window).on('resize.gallerySlider', throttle(function () {
			gallerySlider()
		}, 50))

		/**
			* logo slider
			*/
		new Swiper('.v-logos--slider--normal .v-logos__slider', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				540: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				},
				996: {
					slidesPerView: 5
				}
			}
		})

		new Swiper('.v-logos--slider--large .v-logos__slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				992: {
					slidesPerView: 3
				}
			}
		})

		/**
			* news slider
			*/
		new Swiper('.v-news__slider', {
			autoplay: {
				delay: 4000
			},
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1199: {
					slidesPerView: 3
				},
				1399: {
					slidesPerView: 4
				}
			}
		})

		/**
			* advanced content image slider
			*/
		new Swiper('.v-content__advanced-item--image_slider', {
			slidesPerView: 1,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				996: {
					slidesPerView: 3
				}
			}
		})

		/**
			* switch modal
			*/
		$('.switch-modal').click(function () {
			var modal_close = $(this).closest('.modal');
			var modal_open = $(this).data('target');
			$(modal_close).modal('hide');
			$(modal_close).one('hidden.bs.modal', function () {
				$(modal_open).modal('show');
			});
		});
		/**
			* skip link
			*/
		$('.skip-link').click(function (event) {
			event.preventDefault();
			var skipto = $(this).data('skipto');
			if (skipto) {
				var skipPage = $('html, body');

				skipPage.on('mousedown wheel DOMMouseScroll mousewheel touchmove', function () {
					skipPage.stop();
				});

				skipPage.animate({
					scrollTop: $(skipto).offset().top - $('#header').height()
				}, 1000, function () {
					skipPage.off('mousedown wheel DOMMouseScroll mousewheel touchmove')
				})
			}
		});

		// on scroll
		$(window).scroll(function () {
			scrolling(this)
		});

		// scrolling function
		let stickyPoint = 900;

		function scrolling(el) {
			let scroll = $(el).scrollTop()
			// if header out of view, prep it off canvas for being sticky
			if (scroll > stickyPoint) {
				$('#header').addClass('js-sticky')
			} else {
				$('#header').removeClass('js-sticky')
			}
		}

		/**
			* location section
			*/
		// location section hover
		$('.v-locations__mapMarker').hover(function () {
			$('.v-locations__list').addClass('map-hover')
			$('.v-locations__list li').eq($(this).index() - 1).addClass('is-hover')
		}, function () {
			$('.v-locations__list').removeClass('map-hover')
			$('.v-locations__list li').removeClass('is-hover')
		})
		$('.v-locations__list-button').hover(function () {
			$('.v-locations__map').addClass('list-hover')
			$('.v-locations__mapMarker').eq($(this).parent().index()).addClass('is-hover')
		}, function () {
			$('.v-locations__map').removeClass('list-hover')
			$('.v-locations__mapMarker').removeClass('is-hover')
		})
		// toggle address panel
		$('.v-locations__list-button, .v-locations__mapMarker').click(function () {
			const i = $(this).hasClass('v-locations__list-button') ? $(this).parent().index() : $(this).index() - 1
			const $addressPanel = $('.v-locations__address')
			const $addresses = $('.v-locations__addressItem')
			const $locationList = $('.v-locations__list')
			const $locations = $('.v-locations__list li')
			const wasVisible = $addresses.eq(i).hasClass('is-visible')

			$locationList.removeClass('address-active')
			$addressPanel.removeClass('is-active')
			$locations.removeClass('is-active').removeClass('is-hover')
			$addresses.removeClass('is-visible')
			if (!wasVisible) {
				$locationList.addClass('address-active')
				$addressPanel.addClass('is-active')
				$locations.eq(i).addClass('is-active')
				$addresses.eq(i).addClass('is-visible')
			}
		})
		// close address panel
		$('.v-locations__addressClose').click(function () {
			$('.v-locations__list').removeClass('address-active')
			$('.v-locations__list li').removeClass('is-active')
			$('.v-locations__address').removeClass('is-active')
			$('.v-locations__addressItem').removeClass('is-visible')
		})

		/**
			* advanced focus handling
			*/
		$('.v-panels__button').click(function () {
			$(this).next().focus()
		})

		/**
			* social sharing
			*/
		$('.v-share__btn--general').click(function () {
			if (navigator.share) {
				navigator.share({
					url: $(this).data('url'),
					title: $(this).data('title'),
					text: $(this).data('text')
				})
			} else {
				$.fancybox.open({
					src: '#social-share-modal'
				})
			}
		})

		$('.v-share-modal__copy-button').click(function () {
			let link = $(this).prev()[0]
			let currentFocus = document.activeElement
			link.focus()
			link.setSelectionRange(0, link.value.length)
			let success
			try {
				success = document.execCommand('copy')
			} catch (e) {
				success = false
			}
			if (currentFocus && typeof currentFocus.focus === 'function') {
				currentFocus.focus()
			}

			if (success) {
				let parent = $(this).parent()
				parent.removeClass('is-copied')
				void parent[0].offsetWidth
				parent.addClass('is-copied')
			}
		})

		/**
			* download links
			*/
		if ($('#download-form').length) {
			$('.u-downloadLink').click(function (e) {
				const storageKey = 'download-form'
				const hasFilled = !!sessionStorage.getItem(storageKey)

				// if form has been filled, exit early
				if (hasFilled) return

				const url = e.target.href
				$('#download-form [data-inputname="download-url"]').val(url)

				e.preventDefault()
				$.fancybox.open({
					src: '#download-form',
					type: 'inline',
					opts: {
						afterShow: function () {
							$(document).on('gform_confirmation_loaded', function () {
								$('.e-downloadForm__link').attr('href', url)
								$('.e-downloadForm__header').remove()
								sessionStorage.setItem(storageKey, true)
								window.location.href = url
							})
						}
					}
				})
			})
		}

		/**
			* gravity extra fields animation
			*/
		$('.expand-extra input').on('change', function () {
			if ($(this).prop("checked")) {
				$(this).closest('.gform_body').addClass('show-expand');
			} else {
				console.log('there');
				$(this).closest('.gform_body').removeClass('show-expand');
			}
		});

		/**
			* footer
			*/
		// mobile footer 'accordion' on mobile
		$('.footer-accordion-button').click(function () {
			if ($(window).width() < 996) {
				$(this)
					.closest('.accordion')
					.toggleClass('shown')
			}
		})

	}

	function gridSlider() {
		if ($('.v-gridSlider').length) {
			let rows = 2
			if ($(window).width() < 768) {
				rows = 1
			}
			$('.v-gridSlider .tg-layout-grid').data('row', rows)
			tgInit()

			const rightArrow = $('.v-gridSlider__arrow.tg-right-arrow')
			rightArrow.before(rightArrow.next())

			const MutationObserver = window.MutationObserver || window.WebKitMutationObserver
			const observer = new MutationObserver(throttle(gridSliderMutation, 300))
			const obsConfig = {
				attributeFilter: ['style'],
				attributes: true,
				characterData: false,
				subtree: false
			}

			$('.v-gridSlider .tg-layout-grid').each(function () {
				observer.observe(this, obsConfig)
			})
		}
	}

	function gridSliderMutation(mutationRecords) {
		$.each(mutationRecords, function (i, mutation) {
			const $gridSlider = $(mutation.target)
			const width = $gridSlider.parent().outerWidth()

			const transform = $gridSlider.css('transform')
			let matrixIndex
			if (transform.substring(0, 8) === 'matrix3d') {
				matrixIndex = 13
			} else {
				matrixIndex = 4
			}
			const transformX = parseFloat(transform.match(/-?[\d.]+/g)[matrixIndex])

			$gridSlider.children().each(function () {
				const left = parseFloat($(this).css('left'))
				const center = left + ($(this).outerWidth() / 2)
				const offset = center + transformX

				if (offset > -10 && offset < width + 10) {
					$(this).addClass('tg-item-active')
				} else {
					$(this).removeClass('tg-item-active')
				}
			})
		})
	}

	function animateOut() {
		// hide nav
		$('#site-navigation').removeClass('toggled')
		$('#nav-toggle').removeClass('toggled')
	}

	function unload() {
		// close any open fancybox instances
		$.fancybox.close()

		// header bg fade in
		$(document).off('scroll.headerbg')
		$(document).off('resize.headerbg')

		// footer
		$('.footer-accordion-button').off('click')
	}

	// set scrollbar
	function setScrollbar() {
		var body = document.querySelector('body')
		if (window.innerWidth > body.clientWidth + 5) {
			$('body').removeClass('no-scrollbar')
			document.documentElement.style.setProperty(
				'--scrollbar-width',
				window.innerWidth - body.clientWidth + 'px'
			)
		} else {
			$('body').addClass('no-scrollbar')
		}
	}

	// Returns a function, that, when invoked, will only be triggered at most once
	// during a given window of time. Normally, the throttled function will run
	// as much as it can, without ever going more than once per `wait` duration;
	// but if you'd like to disable the execution on the leading edge, pass
	// `{leading: false}`. To disable execution on the trailing edge, ditto.
	function throttle(func, wait, options) {
		var context, args, result
		var timeout = null
		var previous = 0
		if (!options) options = {}
		var later = function () {
			previous = options.leading === false ? 0 : Date.now()
			timeout = null
			result = func.apply(context, args)
			if (!timeout) context = args = null
		}
		return function () {
			var now = Date.now()
			if (!previous && options.leading === false) previous = now
			var remaining = wait - (now - previous)
			context = this
			args = arguments
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout)
					timeout = null
				}
				previous = now
				result = func.apply(context, args)
				if (!timeout) context = args = null
			} else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining)
			}
			return result
		}
	}

	vehicleslider = new Swiper(".vehicleSwiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		autoplay: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	})


	var swiper1 = new Swiper(".brandSwiper", {
		slidesPerView: 1,
		spaceBetween: 20,
		freeMode: true,
		autoplay: true,
		breakpoints: {
			540: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		},
	});


	/**
	* Gallery
	**/

	// let fancyOptions = {
	// 	buttons: [
	// 		'share',
	// 		'thumbs',
	// 		'slideShow',
	// 		'close'
	// 	],
	// 	arrows: true,
	// 	toolbar: true,
	// 	animationEffect: 'fade',
	// 	thumbs: {
	// 		autoStart: true
	// 	}
	// }

	// $(".js-gallery-filtered .isotope-gallery a").fancybox(fancyOptions);

	// function filterGallery(el, gallery) {
	// 	let filter = $(el).val() !== 'all' ? '[data-cat=' + $(el).val() + ']' : ''
	// 	gallery.isotope({ filter: filter })
	// }

	// let gallery = $('.js-gallery-filtered .isotope-gallery').isotope({
	// 	itemSelector: '.card',
	// 	percentPosition: true,
	// 	layoutMode: 'fitRows'
	// });

	// //on input change
	// $('.js-gallery-filtered .filters input').change(function () {
	// 	//isotop
	// 	filterGallery(this, gallery)
	// 	history.pushState('', '', '?filter=' + $(this).val())
	// 	$('.js-gallery-filtered .filter-btn').removeClass('active');
	// 	$(this).parent('.filter-btn').addClass('active');
	// 	//fancybox
	// 	$.fancybox.destroy();
	// 	if ($(this).val() == 'all') {
	// 		$(".js-gallery-filtered .isotope-gallery a").fancybox(fancyOptions);
	// 	} else {
	// 		$(".js-gallery-filtered .isotope-gallery [data-rel='" + $(this).val() + "']").fancybox(fancyOptions);
	// 	}
	// })

	function showAccreditation() {
		$('.v-pageHead--titlebar .accreditation').addClass('display');
	}

	$('#enquireModal').on('show.bs.modal', function (event) {
		var button = $(event.relatedTarget) // Button that triggered the modal
		var title = button.data('trailer') // Extract info from data-* attributes
		// If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
		// Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
		var modal = $(this)
		modal.find('.modal-title').text('Enquire about ' + title)
		//modal.find('#input_2_3').val(title)
	})



	$(document).ready(function () {
		$(document).on('change', '#car-filter', function () {
			$('#filter-form').submit()
		})

		if ($('.v-pageHead--titlebar .motorhome').length) {
			$('.v-pageHead--titlebar .motorhome').addClass('display');
			$('.v-pageHead--titlebar .caravan').addClass('display');
			setTimeout(() => {
				showAccreditation();
			}, 500);

		}
	})

})(jQuery);
